import { combineReducers } from 'redux';

import i18nReducer from './i18n';
import createNamedWrapperReducer from './name-wrapper-factory';
import modalReducer from './modal';
import cartReducer from '../../cart/reducers';
import httpReducer from './http';
import auth from './auth';
import { sellTicketsUiReducer } from '../../sell/reducers/sell-tickets';
import { CONTACT_DETAILS_MODAL, DONE_MODAL, LOGIN_MODAL_NAME, OTHER_PROVIDER_MODAL_NAME, ADD_TICKETS_MODAL_NAME,
    FORGOT_PASSWORD_MODAL_NAME }
    from '../../sell/constants/modal';
import { AUTH_REQUEST_NAME, CART_TICKETS_REQUEST_NAME } from '../../cart/api/config';
import { SELL_GET_TICKETS_REQUEST_NAME, SELL_SAVE_TICKETS_REQUEST_NAME } from '../../sell/actions/sell-tickets';

const UIReducers = combineReducers({
    http: combineReducers({
        [CART_TICKETS_REQUEST_NAME]: createNamedWrapperReducer(httpReducer, CART_TICKETS_REQUEST_NAME),
        [SELL_GET_TICKETS_REQUEST_NAME]: createNamedWrapperReducer(httpReducer, SELL_GET_TICKETS_REQUEST_NAME),
        [SELL_SAVE_TICKETS_REQUEST_NAME]: createNamedWrapperReducer(httpReducer, SELL_SAVE_TICKETS_REQUEST_NAME),
        [AUTH_REQUEST_NAME]: createNamedWrapperReducer(httpReducer, AUTH_REQUEST_NAME),
    }),
    modal: combineReducers({
        [LOGIN_MODAL_NAME]: createNamedWrapperReducer(modalReducer, LOGIN_MODAL_NAME),
        [CONTACT_DETAILS_MODAL]: createNamedWrapperReducer(modalReducer, CONTACT_DETAILS_MODAL),
        [DONE_MODAL]: createNamedWrapperReducer(modalReducer, DONE_MODAL),
        [OTHER_PROVIDER_MODAL_NAME]: createNamedWrapperReducer(modalReducer, OTHER_PROVIDER_MODAL_NAME),
        [ADD_TICKETS_MODAL_NAME]: createNamedWrapperReducer(modalReducer, ADD_TICKETS_MODAL_NAME),
        [FORGOT_PASSWORD_MODAL_NAME]: createNamedWrapperReducer(modalReducer, FORGOT_PASSWORD_MODAL_NAME),
        ticketCode: createNamedWrapperReducer(modalReducer, 'ticketCode'),
    }),
    sellTickets: sellTicketsUiReducer,
});

const dataReducers = combineReducers({
    cart: cartReducer,
    auth,
    i18n: i18nReducer,
});

const rootReducer = combineReducers({
    data: dataReducers,
    ui: UIReducers,
});

export default rootReducer;
